export const GET_USERS_LIST = 'GET_USERS_LIST';
export const SET_USERS_LIST = 'SET_USERS_LIST';
export const SAVE_USERS_LIST = 'SAVE_USERS_LIST';
export const DELETE_USER_LIST = 'DELETE_USER_LIST';
